"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _Translations = require("react-platform-components/dist/Translations");
var _reactRedux = require("react-redux");
var _config = require("../../config");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function Kitty(props) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentKittyBalance = _useState2[0],
    setCurrentKittyBalance = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    kittyAmount = _useState4[0],
    setKittyAmount = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showKittyField = _useState6[0],
    setShowKittyField = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    addedKitty = _useState8[0],
    setAddedKitty = _useState8[1];
  var _useSelector = (0, _reactRedux.useSelector)(function (_ref) {
      var auth = _ref.auth;
      return {
        user: auth.user
      };
    }),
    user = _useSelector.user;
  (0, _react.useEffect)(function () {
    addedKitty && props.handleKitty(parseFloat(kittyAmount));
  }, [kittyAmount, addedKitty]);
  (0, _react.useEffect)(function () {
    dispatch({
      type: 'FETCH_USER',
      params: {
        _embed: 'wallets'
      }
    });
  }, []);
  (0, _react.useEffect)(function () {
    var _user$wallets;
    var walletIndex = (_user$wallets = user.wallets) === null || _user$wallets === void 0 ? void 0 : _user$wallets.findIndex(function (wallet) {
      return wallet.type === 'KITTY';
    });
    if (walletIndex > -1) setCurrentKittyBalance(+(user.wallets[walletIndex].available_balance * _config.KITTY_EXCHANGE_RATE).toFixed(12));
  }, [user.wallets]);
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "overline"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Current cashback balance:",
    defaultMessage: "Current cashback balance:"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "ml-2 text-lg font-bold"
  }, currentKittyBalance))), currentKittyBalance && !showKittyField ? /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12,
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: "mt-4",
    size: "small",
    variant: "contained",
    color: "secondary",
    onClick: function onClick() {
      return setShowKittyField(true);
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, null, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Use cashback",
    defaultMessage: "Use cashback"
  })))) : null, showKittyField && !addedKitty && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    alignContent: "center",
    justify: "flex-between"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 8
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    type: "number",
    name: "cashback",
    label: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Cashback amount",
      defaultMessage: "Cashback amount"
    }),
    value: kittyAmount,
    variant: "outlined",
    size: "small",
    fullWidth: true,
    required: true,
    onChange: function onChange(event) {
      return setKittyAmount(event.target.value);
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12,
    md: 4,
    alignContent: "center",
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: "mt-4 md:mt-0",
    size: "small",
    variant: "contained",
    color: "secondary",
    onClick: function onClick() {
      return setAddedKitty(kittyAmount / _config.KITTY_EXCHANGE_RATE);
    },
    disabled: kittyAmount && Number(kittyAmount) > 0 && currentKittyBalance - kittyAmount >= 0 ? false : true
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, null, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Save",
    defaultMessage: "Save"
  }))))), addedKitty && kittyAmount && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    alignContent: "center",
    justify: "flex-between"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "overline"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Cashback to use:",
    defaultMessage: "Cashback to use:"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "ml-2 text-lg font-bold"
  }, kittyAmount))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 4,
    alignItems: "center",
    justify: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: function onClick() {
      setAddedKitty(false);
      setKittyAmount(null);
      setShowKittyField(false);
      props.handleKitty(null);
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    style: {
      fontSize: '1.2rem'
    }
  }, "delete")))));
}
var _default = Kitty;
exports.default = _default;